baseApp.directive('balloonList', function() {
    return {
        templateUrl: '/public/directives/balloonList.html',
        scope: {
            items: "=?",
            options: "=",
            anyClick: "=",
            bucket: "="
        },
        link: function($scope, $elem) {
            var i, myHeight, currentRows;
            var $el = $($elem[0]);
            var $elList = $el.find('.list');
            var $shortList = $elList.find('.short');
            var $longList = $el.find('.long');
            var $more = $el.find('.more');
            var $balloon = $el.find('.balloon');
            var  svgns = "http://www.w3.org/2000/svg";
            var  xlinkns = "http://www.w3.org/1999/xlink";

            $scope.$watch('items', function(newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue)) {
                    init();
                }

            }, true);

            $el.click(function(event){
                var $li, item;
                var classes = event.target.className;


                if(typeof classes == "object" && classes.baseVal.indexOf('icon-tag-x') > -1 ){
                    $li = $(event.target.parentElement);
                    item = _.find($scope.items, {id:$li.data('id')});

                    $scope.removeItem(item, $li[0]);

                    if($scope.options.onremove){
                        $scope.options.onremove(item);
                    }


                    event.stopPropagation();
                }
                else if(typeof classes != "object" && event.target.className.indexOf('item') > -1 ){
                    $li = $(event.target.parentElement);
                    item = _.find($scope.items, {id:$li.data('id')});

                    if($scope.options.onclick){
                        $scope.options.onclick(item);
                    }
                    event.stopPropagation();
                }
            });

            $scope.toggleBalloon = function(){
                event.stopPropagation();
                if($balloon.hasClass('open')){
                    closeBalloon();
                }
                else {
                    openBalloon();
                }
            };

            function closeBalloon(){
                $balloon.slideUp();
                $balloon.removeClass('open');
            }

            function openBalloon(){
                $balloon.slideDown();
                $balloon.width($shortList.width() - 20);
                $balloon.addClass('open');
            }


            $scope.removeItem = function(item, el){
                var listIndex = $scope.items.indexOf(item);
                $scope.items.splice(listIndex, 1);
                if($scope.shortList.indexOf(item) > -1){
                    $scope.shortList.splice($scope.shortList.indexOf(item), 1);
                    $(el).remove();
                }
                else {
                    $scope.fl.splice($scope.fl.indexOf(item), 1);
                    $(el).remove();
                }

                if($scope.items.length > $scope.shortList.length && $scope.items.length > $scope.shortList.length){
                    if(addToShortList($scope.items[$scope.shortList.length])){
                        buildLongList();
                        if($scope.fl.length > 0){
                            $more.css('display', 'inline-block');
                            $shortList.append($more);
                        }
                        else {
                            $more.css('display', 'none');
                        }
                    }
                }
                else {
                    closeBalloon();
                }
            };



            function createEl(item, $list){
                var tempLi = document.createElement('li');

                if($scope.options.icons){
                    if($scope.options.icons[item.icon || item.type]){
                        var iconSvg = document.createElementNS(svgns, 'svg');
                        iconSvg.setAttribute("class", "icon icon-tag-" + $scope.options.icons[item.icon || item.type]);

                        var iconUseEl = document.createElementNS(svgns, 'use');
                        iconUseEl.setAttributeNS(xlinkns, "href", "/public/images/icons/main.svg#icon-tag-" + $scope.options.icons[item.icon || item.type]);

                        iconSvg.appendChild(iconUseEl);
                        tempLi.appendChild(iconSvg);
                    }
                }
                tempLi.className = "tag";

                var nameSpan = document.createElement('span');
                nameSpan.className = "item";
                nameSpan.innerText = item.name;
                tempLi.appendChild(nameSpan);

                if($scope.options.removeItem){
                    var removeSvg = document.createElementNS(svgns, 'svg');
                    var classAttr = "icon icon-tag-x";

                    if($scope.options.noDisable){
                        classAttr += ' no-disable';
                    }

                    removeSvg.setAttribute("class",classAttr);

                    var useEl = document.createElementNS(svgns, 'use');
                    useEl.setAttributeNS(xlinkns, "href", "/public/images/icons/main.svg#icon-tag-x");

                    removeSvg.appendChild(useEl);
                    tempLi.appendChild(removeSvg);
                }

                $list.append(tempLi);

                $(tempLi).data('id', item.id);

                return tempLi;
            }

            function addToShortList(item){
                var newEl = createEl(item, $shortList);

                if($shortList.height() > myHeight) {
                    currentRows++;
                }
                if(currentRows > $scope.options.rows){
                    $(newEl).remove();
                    currentRows = $scope.options.rows;
                    return false;
                }
                else {

                    myHeight = $shortList.height();
                    $scope.shortList.push(item);
                    if($scope.fl.indexOf(item) > -1) {
                        $scope.fl.splice($scope.fl.indexOf(item), 1);
                    }
                    return true;
                }
            }

            function buildLongList(){
                $longList.empty();
                for(i=0;$scope.fl[i];i++){
                    createEl($scope.fl[i], $longList);
                }
            }

            function init(){
                $scope.shortList = [];
                $scope.fl = [];
                $shortList.empty();
                myHeight = 0;
                currentRows = 0;
                $more.css('display', 'inline-block');

                for(i=0;$scope.items[i];i++){
                    if(!addToShortList($scope.items[i])){
                        $scope.fl = $scope.items.slice(i);
                        break;
                    }
                    $shortList.append($more);
                }
                if($scope.fl.length === 0){
                    $more.css('display', 'none');
                }
                else {
                    $more.css('display', 'inline-block');

                    buildLongList();
                }
            }

            init();


        }
    };
});